module.exports = __webpack_public_path__ + "public/img/photoImport2.9c081bd8.svg";